import { render, staticRenderFns } from "./StockDelay.vue?vue&type=template&id=65b65e46&"
import script from "./StockDelay.vue?vue&type=script&lang=js&"
export * from "./StockDelay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports